import style from "./style.module.sass"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import config from "../../../../config"

export default function ComplianceLevelBar() {
    const { theme: { bgColors, colors } } = useTheme()
    const { t } = useTranslation()
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const resultData = useSelector(state => state.analyseData.result.resultData)

    const complianceData = resultData['dataCompliance'] || {}
    const complianceLevel = complianceData.complianceLevel ? t(`analysis_compliance-level-${complianceData.complianceLevel}`) : t('analysis_compliance-level-unknown')
    const complianceLevelColor = config.complianceLevelToString.find(v => v.level === complianceData.complianceLevel)?.color || colors.colorPrimary700
    return <div className={style.firstPart} title={t('analysis_compliance-level')} style={{ backgroundColor: bgColors.bgPrimary0, padding: '8px 22px 8px', gridGap: '4px', flex: 1 }}>
    <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`${style.title}`}>{t("analysis_compliance-level")}</p>
    <div className="d-flex align-items-center justify-content-center">
        <h3 style={{ color: isContrast ? colors.colorContrast : complianceLevelColor, fontSize: '1.2rem' }}>
            {complianceLevel}
        </h3>
    </div>
</div>
}